import { observe, ObservableMap } from 'mobx';
import * as React from 'react';
import { IStory } from '../../Stores/StoryStore';
import { styles } from './PhotoViewerStyles';

import { colors } from '../../styles/colors';

// import { RightPhotoArrow, LeftPhotoArrow } from '../../images/images';

interface IProps {
    story: IStory;
    selectedIndex: number;
    onClick(index: number, story: IStory): void;
    onClickLeft(): void;
    onClickRight(): void;
}
export class PhotoCarousel extends React.Component<IProps> {
    private imagesLoaded = new ObservableMap<string, boolean>();

    public componentDidMount(): void {
        // Watch the list if loaded images, and scroll to the selected item when they're all loaded.
        observe(this.imagesLoaded, () => {
            if (this.imagesLoaded.size === this.props.story.photosWithComments.length) {
                this.scrollToFocusIndex();
                clearTimeout(scrollTimeout); // We don't need the backup timeout method any more
            }
        });
        // As a backup, try scrolling to the selected item after 1 second
        const scrollTimeout = window.setTimeout(() => this.scrollToFocusIndex(), 1000);
    }

    public componentDidUpdate(prevProps: IProps): void {
        if (prevProps.selectedIndex !== this.props.selectedIndex) {
            this.scrollToFocusIndex();
        }
    }

    private scrollToFocusIndex(): void {
        const itemComponent = this.refs.activeItem as HTMLDivElement;
        if (itemComponent) {
            itemComponent.scrollIntoView({
                behavior: 'smooth'
            });
        }
    }

    private getImageStyle(active: boolean) {
        const style = {
            borderWidth: 2,
            borderStyle: 'solid',
            borderColor: colors.ORANGE,
        };
        return style;
    }

    public render() {
        const { story, selectedIndex, onClick } = this.props;

        function getImageStyle(active: boolean) {
            if (active) {
                return {
                    borderWidth: 2,
                    borderStyle: 'solid',
                    borderColor: colors.ORANGE,
                };
            }
            return {};
        }

        return (
            <div style={styles.carouselContainer} className={'customScrollBar customScrollBar--light customScrollBar--narrow '}>
                {[...story.photosWithComments].map((img, index) => {
                    const dynamicProps = {} as React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

                    //https://stackoverflow.com/a/30497101/93345
                    if (index === this.props.selectedIndex) {
                        dynamicProps.ref = 'activeItem';
                    }

                    return (
                        <div key={img.photo.id}>
                                                        <span className={'photoGrid__item__label'}>
                                {img.photo.index + 1}
                            </span>
                            <div id={index.toString()}  style={styles.imageContainer}
                                 {...dynamicProps}
                                 onClick={() => onClick(index, story)}>

                                <img
                                    onLoad={() => this.imagesLoaded.set(index.toString(), true)}
                                    onError={
                                        // We only care about all possible images being loaded, so
                                        // errors count as loads for our purposes
                                        () => this.imagesLoaded.set(index.toString(), true)
                                    }
                                    style={{...styles.imageStyle, ...getImageStyle(index === selectedIndex)}}
                                    src={img.photo.thumbnail_url || img.photo.url}
                                    key={index}
                                />
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Pages/PhotoViewer/PhotoCarousel.tsx